// Remove focus animation for mouse users
// Adapted from https://github.com/lindsayevans/outline.js/blob/master/outline.js

const styleElement = document.createElement('STYLE');

function setCss(cssText) {
   styleElement.innerHTML = cssText;
}

document.getElementsByTagName('HEAD')[0].appendChild(styleElement);

// Using mousedown instead of mouseover, so that previously focused elements don't lose focus ring on mouse move
// For mouse users, we don't want an outline or any other kind of animation on mousedown.
document.addEventListener('mousedown', function() {
  styleElement.innerHTML = 'a:focus,button:focus{outline:none;};';
});

// For keyboard users, we add an extra animation for accessibility.
document.addEventListener('keydown', function() {
  styleElement.innerHTML = 'a,button{transition:position 500ms;}a:focus,button:focus{outline:none;position:relative;bottom:2px;}';
});
